<template>
  <div class="main">
    <img
      :src="item.coverUrl"
      style="width: 100%; height: 160px; border-radius: 12px 12px 0 0"
    />
    <div class="se-msg">
      <div class="se-p-b-20 se-bb">
        <div class="ft-16-000 se-m-b-10 course-name">
          {{ item && item.courseName ? item.courseName : "" }}
        </div>
        <div class="ft-14-666 txt">
          {{ item && item.courseSummary ? item.courseSummary : "" }}
        </div>
      </div>
      <div>
        <div class="se-flex se-p-t-10">
          <img
            src="../../assets/icons/time.png"
            style="width: 16px; height: 16px"
          />
          <div class="ft-12-666 se-m-l-10">
            {{ item.passTime ? item.passTime : "" }}
          </div>
        </div>
        <div class="se-flex se-p-t-10">
          <img
            src="../../assets/icons/cap.png"
            style="width: 18px; height: 16px"
          />
          <div class="ft-12-666 se-m-l-10" style="white-space: nowrap">
            学习次数：{{ item && item.count ? item.count : 0 }}次
          </div>
        </div>
        <div class="se-flex jcsb aic se-p-t-10">
          <div class="se-flex">
            <img
              src="../../assets/icons/user.png"
              style="width: 17px; height: 17px"
            />
            <div class="ft-12-666 se-m-l-10">
              {{ item && item.teacherName ? item.teacherName : "暂无" }}
            </div>
          </div>
          <div class="se-p-l-10 se-flex aic" style="white-space: nowrap">
            <div class="se-line se-p-r-10"></div>
            <!-- <span class="ft-16-yellow">9.3</span> -->
            <span class="ft-16-yellow">{{
              item && item.star ? item.star : 0
            }}</span>
            <span class="ft-12-666">星</span>
          </div>
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    from: {
      Type: String,
      default: "",
    },
    item: {
      Type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  > img {
    object-fit: cover;
    transition: transform 0.3s;
  }
  &:hover {
    > img {
      transform: scale(1.1);
    }
  }
}

.se-msg {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.se-bb {
  flex: 1;
  border-bottom: 1px solid #f0f0f0;
}

.se-line {
  height: 12px;
  width: 1px;
  height: 12px;
  border-left: 1px solid #a9a9a9;
}

.txt {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.course-name {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
